// extracted by mini-css-extract-plugin
export default {"customerReviewsPage":"styles_customerReviewsPage__njaAw","conatiner":"styles_conatiner__SpqkR"};